import { Box } from "@material-ui/core";
import { amber, green } from "@material-ui/core/colors";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import WarningIcon from "@material-ui/icons/Warning";
import clsx from "clsx";
import React, { FC } from "react";

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

const useStyles = makeStyles((theme) => ({
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.main,
    },
    warning: {
        backgroundColor: amber[700],
    },
    icon: {
        color: "white",
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: "flex",
        alignItems: "center",
        color: "white",
        flexGrow: 1,
    },
    closeIcon: {
        padding: 0,
    },
}));

interface MessageProps {
    variant: "success" | "warning" | "error" | "info";
    message?: string;
    onClose?: any;
    show: boolean;
    style?: React.CSSProperties;
}

const Message: FC<MessageProps> = ({
    variant,
    message,
    show,
    onClose,
    style,
}) => {
    const classes = useStyles();
    const Icon = variantIcon[variant];

    if (!show) {
        return null;
    }

    return (
        <Box
            display="flex"
            borderRadius={2}
            p={2}
            className={classes[variant]}
            style={style}
        >
            <span className={classes.message}>
                <Icon className={clsx(classes.icon, classes.iconVariant)} />
                {message}
            </span>
            {onClose && (
                <IconButton className={classes.closeIcon}>
                    <CloseIcon
                        className={clsx(classes.icon)}
                        onClick={onClose}
                    />
                </IconButton>
            )}
        </Box>
    );
};

export { Message };
